import MojitoPresentation from 'mojito/presentation';

const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;

/**
 * Sport tab selector types.
 *
 * @class SportTabSelectorTypes
 * @name types
 * @memberof Mojito.Modules.SportTabSelector
 */

/**
 * Tab data item.
 *
 * @typedef TabDataItem
 * @type {object}
 * @property {string} name - Lowercase name.
 * @property {object} analyticsData - Analytics data.
 * @property {Function} routeFn - Function to build navigation object. Typically a Mojito.Presentation.Base.Navigation.NavigationPathBuilder function.
 * @property {string} className - Class name used for testing.
 * @property {string} icon - Tabs icon src.
 *
 * @memberof Mojito.Modules.SportTabSelector.types
 */

/**
 * Sport tab selector data.
 * The order of the list decides the order of the tabs shown in the selector.
 *
 * @enum {Array<Mojito.Modules.SportTabSelector.types.TabDataItem>}
 * @memberof Mojito.Modules.SportTabSelector.types
 */
export const SPORT_TABS = [
    {
        name: 'competitions',
        analyticsData: {
            type: 'matchSportMainNavigationClicked',
            linkName: 'Competitions',
        },
        routeFn: NavigationPathBuilder.toSportCompetitions,
        className: 'ta-competitions',
    },
    {
        name: 'matches',
        analyticsData: {
            type: 'matchSportMainNavigationClicked',
            linkName: 'Matches',
        },
        routeFn: NavigationPathBuilder.toSportMatches,
        className: 'ta-matches',
    },
    {
        name: 'highlights',
        analyticsData: {
            type: 'racingMainNavigationClicked',
            linkName: 'Highlights',
        },
        routeFn: NavigationPathBuilder.toSportHighlights,
        className: 'ta-highlights',
    },
    {
        name: 'meetings',
        analyticsData: {
            type: 'racingMainNavigationClicked',
            linkName: 'Meetings',
        },
        routeFn: NavigationPathBuilder.toSportMeetings,
        className: 'ta-meetings',
    },
    {
        name: 'priceBoosts',
        analyticsData: {
            type: 'sportMainNavigationClicked',
            linkName: 'PriceBoosts',
        },
        routeFn: NavigationPathBuilder.toSportPriceBoosts,
        className: 'ta-price-boosts',
        icon: 'promotion-priceenhancement',
    },
    {
        name: 'preBuiltBetBuilders',
        analyticsData: {
            type: 'sportMainNavigationClicked',
            linkName: 'PrebuiltBetBuilders',
        },
        routeFn: NavigationPathBuilder.toSportPreBetBuilders,
        className: 'ta-pre-built-bet-builders',
        icon: 'system-betbuilder',
    },
    {
        name: 'outrights',
        analyticsData: {
            type: 'sportMainNavigationClicked',
            linkName: 'Outrights',
        },
        routeFn: NavigationPathBuilder.toSportOutright,
        className: 'ta-outrights',
    },
    {
        name: 'future',
        analyticsData: {
            type: 'sportMainNavigationClicked',
            linkName: 'Future',
        },
        routeFn: NavigationPathBuilder.toSportFuture,
        className: 'ta-future',
    },
];

/**
 * Type tab selector data.
 * The order of the list decides the order of the tabs shown in the selector.
 *
 * @enum {Array<Mojito.Modules.SportTabSelector.types.TabDataItem>}
 * @memberof Mojito.Modules.SportTabSelector.types
 */
export const TYPE_TABS = [
    {
        name: 'matches',
        analyticsData: {
            type: 'leagueNavigationClicked',
            linkName: 'Matches',
        },
        routeFn: NavigationPathBuilder.toSportMatchesLeague,
        className: 'ta-matches',
    },
    {
        name: 'priceBoosts',
        analyticsData: {
            type: 'leagueNavigationClicked',
            linkName: 'PriceBoosts',
        },
        routeFn: NavigationPathBuilder.toSportPriceBoostsLeague,
        className: 'ta-price-boosts',
        icon: 'promotion-priceenhancement',
    },
    {
        name: 'preBuiltBetBuilders',
        analyticsData: {
            type: 'leagueNavigationClicked',
            linkName: 'preBuiltMatchAcca',
        },
        routeFn: NavigationPathBuilder.toSportPreBetBuildersLeague,
        className: 'ta-pre-built-match-acca',
        icon: 'system-betbuilder',
    },
    {
        name: 'table',
        analyticsData: {
            type: 'leagueNavigationClicked',
            linkName: 'Table',
        },
        routeFn: NavigationPathBuilder.toSportTableLeague,
        className: 'ta-table',
    },
];
